import { render, staticRenderFns } from "./WorkflowHistoryMessageModal.vue?vue&type=template&id=77d7e4b0&scoped=true&"
import script from "./WorkflowHistoryMessageModal.vue?vue&type=script&lang=js&"
export * from "./WorkflowHistoryMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d7e4b0",
  null
  
)

export default component.exports